export const ANALYTICS_EVENTS = {
  E2E_FLOW_WIZARD_VIEWED: 'E2E_FLOW_WIZARD_VIEWED',
  E2E_FLOW_WIZARD_DISMISSED: 'E2E_FLOW_WIZARD_DISMISSED',
  TEAM_MEMBER_INVITED: 'TEAM_MEMBER_INVITED',
}

const REQUEST_LOGS_STATUS_VALUES = ['all', 'success', 'failed'] as const
const REQUEST_LOGS_DATE_RANGE_VALUES = ['1d', '1w', '1m', '3m'] as const

export type REQUEST_LOGS_STATUS_VALUES =
  (typeof QUERY_PARAMS.REQUEST_LOGS.STATUS.availableValues)[number]
export type REQUEST_LOGS_DATE_RANGE_VALUES =
  (typeof QUERY_PARAMS.REQUEST_LOGS.DATE_RANGE.availableValues)[number]
export const QUERY_PARAMS = {
  REQUEST_LOGS: {
    STATUS: {
      key: 'status',
      defaultValue: REQUEST_LOGS_STATUS_VALUES[0],
      availableValues: REQUEST_LOGS_STATUS_VALUES,
    },
    DATE_RANGE: {
      key: 'dateRange',
      defaultValue: REQUEST_LOGS_DATE_RANGE_VALUES[0],
      availableValues: REQUEST_LOGS_DATE_RANGE_VALUES,
    },
    SEARCH_PARAMS: {
      key: 'searchParams',
      defaultValue: [''],
      availableValues: [''],
    },
  },
}
